import script from "./SummaryInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryInfo.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryInfo.vue?vue&type=style&index=0&id=2986f4b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2986f4b5"]])

export default __exports__